import DefaultValidation from '@/services/validations/DefaultValidation';
import * as Util from "@/functions/Util";

export default class CultivarValidation extends DefaultValidation{

    constructor(msgs) {
        super(msgs);
    }

    validate(model, culturaSelected, refs) {
        let validated = true;
        
        if (refs.idcultivarerpInput.required && Util.isNull(model.idcultivarerp)) {
            refs.idcultivarerpInput.focusedOut = true;
            validated = false;
        }
        
        if (Util.isNull(model.descricao)) {
            refs.descricaoInput.focusedOut = true;
            validated = false;
        }

        if (culturaSelected==null) {
            refs.culturaInput.focusedOut = true;
            validated = false;
        }

        return validated;
    }

}